import {SET_CURRENT_PERSONA} from '../session/types';
import * as types from './types';

const categoriesReducer = (
  state = {
    error: null,
    isFetchingCategories: false,
    topLevelCategories: [],
    categoriesTree: [],
    dict: {},
    locale: undefined,
  },
  action,
) => {
  switch (action.type) {
    case types.CATEGORIES_REQUEST:
      return {
        ...state,
        isFetchingCategories: true,
      };
    case types.CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetchingCategories: false,
        topLevelCategories: action.payload.topLevelCategories,
        categoriesTree: action.payload.categoriesTree,
        dict: action.payload.dict,
        locale: action.payload.locale,
      };
    case types.CATEGORIES_ERROR:
      return {
        ...state,
        isFetchingAllCategories: false,
      };

    case SET_CURRENT_PERSONA:
      return {
        ...state,
        categoriesTree: [],
        dict: {},
        locale: undefined,
      };
    default:
      return state;
  }
};

export default categoriesReducer;
